import type { NextApiRequest, NextApiResponse } from 'next';
import { withAuth } from '../../../lib/apiAuth';
import { getSupabaseAdminClient } from '../../../lib/supabaseAdmin';

/**
 * S7: Alert Rules CRUD API
 * GET    /api/alerts/rules - List all rules
 * POST   /api/alerts/rules - Create a new rule
 * PUT    /api/alerts/rules?id=X - Update a rule
 * DELETE /api/alerts/rules?id=X - Delete a rule
 */
async function handler(
  req: NextApiRequest,
  res: NextApiResponse,
  user: { id: string; email: string; roles: string[]; primaryRole: string }
) {
  const supabaseAdmin = getSupabaseAdminClient();

  if (req.method === 'GET') {
    const { data, error } = await supabaseAdmin
      .from('alert_rules')
      .select('*')
      .order('created_at', { ascending: false });
    if (error) return res.status(500).json({ error: error.message });
    return res.status(200).json({ success: true, data });
  }

  if (req.method === 'POST') {
    const { name, description, trigger_type, threshold_value, threshold_unit, severity, recipients, enabled } = req.body;
    if (!name || !trigger_type) {
      return res.status(400).json({ error: 'name y trigger_type son obligatorios.' });
    }
    const { data, error } = await supabaseAdmin.from('alert_rules').insert({
      name, description, trigger_type,
      threshold_value: threshold_value ?? 20,
      threshold_unit: threshold_unit ?? 'percent',
      severity: severity ?? 'warning',
      recipients: recipients ?? ['administracion@externaliza2.com'],
      enabled: enabled ?? true,
    }).select().single();
    if (error) return res.status(500).json({ error: error.message });
    return res.status(201).json({ success: true, data });
  }

  if (req.method === 'PUT') {
    const { id } = req.query;
    if (!id) return res.status(400).json({ error: 'Se requiere id.' });
    const { data, error } = await supabaseAdmin
      .from('alert_rules')
      .update(req.body)
      .eq('id', id as string)
      .select()
      .single();
    if (error) return res.status(500).json({ error: error.message });
    return res.status(200).json({ success: true, data });
  }

  if (req.method === 'DELETE') {
    const { id } = req.query;
    if (!id) return res.status(400).json({ error: 'Se requiere id.' });
    const { error } = await supabaseAdmin.from('alert_rules').delete().eq('id', id as string);
    if (error) return res.status(500).json({ error: error.message });
    return res.status(200).json({ success: true });
  }

  return res.status(405).json({ error: 'Method not allowed' });
}

export default withAuth(handler, ['admin']);
